import {
    FieldConfig,
    SmartMetadataCard,
} from '@common/components/MetadataCard';
import {
    useFormattedDate,
    useFormattedDuration,
} from '@common/hooks/formatters';
import { useSelectedCollectionMetadata } from '@features/Collection/hooks';
import { CollectionMetadata } from '@features/Collection/metadataTypes';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const GlobalInfoSection = () => {
    const { t } = useTranslation('collectionDetails');
    const { data: metadata, isLoading } = useSelectedCollectionMetadata();

    const { formatDate } = useFormattedDate({ year: 'numeric' });
    const { formatDuration } = useFormattedDuration();

    const config: FieldConfig<CollectionMetadata>[] = useMemo(
        () => [
            { key: 'title' },
            { key: 'proscopeId' },
            { key: 'releaseDate', formatter: formatDate },
            { key: 'genres', formatter: (val) => val.join(', ') },
            { key: 'duration', formatter: formatDuration },
            { key: 'productionCountry' },
        ],
        [formatDate, formatDuration],
    );

    const resolveLabel = useCallback(
        (key: keyof CollectionMetadata) => t(`metadata.${key}`),
        [t],
    );

    return (
        <SmartMetadataCard
            title={t('globalInformation')}
            resolveLabel={resolveLabel}
            isLoading={isLoading}
            source={metadata}
            config={config}
        />
    );
};
